import { render, staticRenderFns } from "./EvalUserRequestsDialog.vue?vue&type=template&id=2d283da8&scoped=true"
import script from "./EvalUserRequestsDialog.vue?vue&type=script&lang=js"
export * from "./EvalUserRequestsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d283da8",
  null
  
)

export default component.exports